import React from "react";
import Modal from "react-modal";
import { MdClose } from "react-icons/md";

export function DeclineModal({
  isOpen,
  declineReason,
  onDeclineReasonChange,
  onDecline,
  onClose,
}) {
  return (
    <Modal
      isOpen={isOpen}
      contentLabel="Decline warranty"
      className="confirm-modal warranty-decline-modal"
    >
      <div className="card">
        <button onClick={onClose} className="confirm-modal-close">
          <MdClose />
        </button>
        <form onSubmit={onDecline}>
          <div className="card-header">Reason for decline</div>
          <div className="card-body">
            <textarea
              required
              onChange={onDeclineReasonChange}
              id="declineReason"
              value={declineReason}
              className="form-control"
            />
            <div>Are you sure you want to decline?</div>
          </div>
          <div className="card-footer">
            <button
              type="submit"
              className="btn btn-outline-primary mr-3"
              data-testid="modal-decline-btn"
            >
              Decline
            </button>
            <button
              type="button"
              className="btn btn-outline-secondary"
              data-testid="modal-decline-btn-cancel"
              onClick={onClose}
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </Modal>
  );
}
